import React, {ReactNode, useEffect, useState} from 'react'

interface IInput {
    changeHandler: (data: any) => any,
    blurHandler?: (data: any) => any,
    value: string,
    max?: number,
    min?: number,
    step?: number,
    placeholder?: string,
    disabled?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType<{}>
    validationError?: boolean,
    validationErrorDescription?: string,
    require?: boolean,
    readOnly?: boolean,
    id?: string,
    type?: "button" | "checkbox" | "color" | "date" | "datetime-local" | "email" | "file" | "hidden" | "image" | "month" | "number" | "password" | "radio" | "range" | "reset" | "search" | "submit" | "tel" | "text" | "time" | "url" | "week"
}

const Input: React.FC<IInput> = (
    {
        changeHandler,
        placeholder,
        disabled = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        validationError,
        validationErrorDescription,
        value,
        min,
        max,
        step,
        blurHandler,
        require = true,
        readOnly = false,
        id,
        type = "text"
    }
) => {

    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        setInputValue(value);
    }, [value])

    // @ts-ignore
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setInputValue(e.target.value)
            // @ts-ignore
            blurHandler(e)
        }
    };

    // @ts-ignore
    return (
        <>
            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <>
                        <label
                            className={`block text-gray-600 text-left font-medium mb-1 ${customLabelClassName ? customLabelClassName : ""}`}
                            htmlFor={name}
                        >
                            {label}
                            {require && <span className="text-red-500 px-1">*</span>}
                        </label>
                    </>
                )
            }
            <input
                id={id}
                className={`form-input border px-2 py-1 border-slate-200 rounded-md w-full ${customClassName ? customClassName : ""} ${validationError ? "border border-red-500" : ""}`}
                type={type}
                name={name}
                onChange={e => {
                    setInputValue(e.target.value)
                    if (changeHandler) {
                        changeHandler(e);
                    }
                }}
                onBlur={
                    e => {
                        if (blurHandler) {
                            blurHandler(e);
                        }
                    }
                }
                onKeyDown={handleKeyDown}
                value={inputValue}
                min={min}
                max={max}
                step={step}
                placeholder={placeholder}
                disabled={disabled}
                required={require}
                readOnly={readOnly}
            />
            {
                validationErrorDescription && (
                    <div className="text-xs text-left text-red-500">
                        {validationErrorDescription}
                    </div>
                )
            }
        </>
    )
}

export default Input